import {IMuWidget} from "./IMuWidget";

export class TPFAttaches extends IMuWidget
{
	addDeleted(id : number) {
		this.ui.deleteIds.value += "," + id;
	}
}

export class TPFAttache extends IMuWidget
{
	public id : number;

	bDelete_click() {
		if (confirm("smazat vybraný soubor?")) {
			(this.muParent as TPFAttaches).addDeleted(this.id);
			this.muRemoveSelf();
		}
	}
}
